export default __webpack_public_path__ + "static/media/prbicon_Usuarios.214ab57a.svg";